export const dashboard = {
  logo: "/logo-lexfo.png",
  brand: "/brand-lexfo-uncovery.png",
  favicon: "/favicon.ico",
  theme: {
    dark: {
      name: "dark",
      text: "#ffffff",
      textLight: "#6a6a6a",
      background: "#0d1116",
      surface: "#161c23",
      surfaceSecondary: "#252f3a",
      primary: "#31c5b8",
      onPrimary: "#ffffff",
      secondary: "#9a9a9a",
      onSecondary: "#ffffff",
      ternary: "#A163D2",
      onTernary: "#F2F2F4",
      dark: "#344252",
      onDark: "#F2F2F4",
      link: "#14b5ff",
      blue: "#45a1ee",
      purple: "#52489c",
      green: "#32de8a",
      red: "#ee6352",
      orange: "#f9a620",
      yellow: "#ffd449",
      black: "#1d201f",
      white: "#F2F2F4",
      grey: "#BFBFC0",
    },
    light: {
      name: "light",
      text: "#ffffff",
      textLight: "#6a6a6a",
      background: "#0d1116",
      surface: "#161c23",
      surfaceSecondary: "#1a222a",
      primary: "#B1F9F0",
      onPrimary: "#000000",
      secondary: "#BFBFC0",
      onSecondary: "#F2F2F4",
      ternary: "#A163D2",
      onTernary: "#F2F2F4",
      dark: "#344252",
      onDark: "#F2F2F4",
      link: "#14b5ff",
      blue: "#45a1ee",
      purple: "#52489c",
      green: "#32de8a",
      red: "#ee6352",
      orange: "#f9a620",
      yellow: "#ffd449",
      black: "#1d201f",
      white: "#F2F2F4",
      grey: "#BFBFC0",
    },
  },
};

// 1f2832 theme surface

export const getThemeByName = (name) => {
  return dashboard.theme[name];
};

export const getLogo = () => {
  return dashboard.logo;
};

export const getBrand = () => {
  return dashboard.brand;
};
